import type {
  FirmGenericTabUpdates,
  TabLastSeen,
  TabViewRef,
} from "@shared/types/customer-tab-last-seen";
import { api } from "./client";

function buildQueryString(ref: TabViewRef): string {
  const params = new URLSearchParams({
    target_kind: ref.target_kind,
    target_id: ref.target_id,
    tab_key: ref.tab_key,
  });
  return `?${params.toString()}`;
}

/// 現在ユーザーの (target, tab) の last_seen_at を取得する。 未閲覧なら last_seen_at=null。
export async function getTabLastSeen(ref: TabViewRef): Promise<TabLastSeen> {
  return api.get<TabLastSeen>(
    `/api/customer-tab-last-seen${buildQueryString(ref)}`,
  );
}

/// 現在ユーザーが (target, tab) を「見た」ことを記録し、 upsert 後の last_seen_at を返す。
export async function markTabSeen(ref: TabViewRef): Promise<TabLastSeen> {
  return api.put<TabLastSeen>("/api/customer-tab-last-seen", ref);
}

/// 法律事務所詳細の汎用タブ更新ドット用の派生状態を取得する。
export async function getFirmGenericTabUpdates(
  firmId: string,
): Promise<FirmGenericTabUpdates> {
  const params = new URLSearchParams({ firm_id: firmId });
  return api.get<FirmGenericTabUpdates>(
    `/api/customer-tab-last-seen/firm-generic-updates?${params.toString()}`,
  );
}
